<script>
import $ from 'jquery';
import Sidebar from 'primevue/sidebar';

export default {
  extends: Sidebar,
  props: {
    forceMobile: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['update:visible'],
  updated() {
    if (this.$isMobile()) {
      this.$nextTick(() => {
        $(this.mask).addClass('sidebar-mobile');
      });
    }
  },
  mounted() {
    if (this.forceMobile)
      this.$nextTick(() => {
        $(this.mask).addClass('sidebar-mobile');
      });
  },
};
</script>
